{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://ceo-os.local/schemas/v1/data-export-package.schema.json",
  "title": "DataExportPackage v1",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "schema_name",
    "schema_version",
    "contract_id",
    "produced_at",
    "producer",
    "payload_hash",
    "payload"
  ],
  "properties": {
    "schema_name": { "const": "data-export-package" },
    "schema_version": { "const": "1.0.0" },
    "contract_id": { "type": "string", "format": "uuid" },
    "produced_at": { "type": "string", "format": "date-time" },
    "producer": { "const": "ceo-os" },
    "payload_hash": { "type": "string", "pattern": "^[a-f0-9]{64}$" },
    "payload": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "package_type",
        "database_version",
        "contains_sensitive_data",
        "warning",
        "data"
      ],
      "properties": {
        "package_type": { "const": "full_private_backup" },
        "database_version": { "type": "integer", "minimum": 1 },
        "contains_sensitive_data": { "const": true },
        "warning": { "type": "string", "minLength": 1 },
        "data": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "privateSources",
            "structuredRecords",
            "externalSummaries",
            "constitutions",
            "profiles",
            "boardImports",
            "jointCorrections",
            "auditEvents",
            "exportManifests",
            "importResults",
            "meta"
          ],
          "properties": {
            "privateSources": { "$ref": "#/$defs/recordArray" },
            "structuredRecords": { "$ref": "#/$defs/recordArray" },
            "externalSummaries": { "$ref": "#/$defs/recordArray" },
            "constitutions": { "$ref": "#/$defs/recordArray" },
            "profiles": { "$ref": "#/$defs/recordArray" },
            "boardImports": { "$ref": "#/$defs/recordArray" },
            "jointCorrections": { "$ref": "#/$defs/recordArray" },
            "auditEvents": { "$ref": "#/$defs/recordArray" },
            "exportManifests": { "$ref": "#/$defs/recordArray" },
            "importResults": { "$ref": "#/$defs/recordArray" },
            "meta": {
              "type": "array",
              "items": {
                "type": "object",
                "required": ["key", "value", "updatedAt"],
                "properties": {
                  "key": { "type": "string", "minLength": 1 },
                  "value": {
                    "anyOf": [{ "type": "string" }, { "type": "number" }, { "type": "boolean" }]
                  },
                  "updatedAt": { "type": "string", "format": "date-time" }
                },
                "additionalProperties": false
              }
            }
          }
        }
      }
    }
  },
  "$defs": {
    "persistedRecord": {
      "type": "object",
      "required": ["id", "schemaVersion"],
      "properties": {
        "id": { "type": "string", "format": "uuid" },
        "schemaVersion": { "type": "string", "minLength": 1 }
      },
      "additionalProperties": true,
      "description": "Backup record bodies preserve entity-specific and prior-minor fields. The package and store list remain strict; unsupported package versions fail before restore."
    },
    "recordArray": {
      "type": "array",
      "items": { "$ref": "#/$defs/persistedRecord" }
    }
  },
  "examples": [
    {
      "schema_name": "data-export-package",
      "schema_version": "1.0.0",
      "contract_id": "e56acaa5-16d4-4ccf-a8ce-cf97b795ba1a",
      "produced_at": "2026-07-26T22:00:00+08:00",
      "producer": "ceo-os",
      "payload_hash": "a34e8e3ac6f093c5d92f8186f92b2a64de1f47b592efdac194d44d659203518a",
      "payload": {
        "package_type": "full_private_backup",
        "database_version": 2,
        "contains_sensitive_data": true,
        "warning": "包含私人原文，不适合发送给董事会 OS。",
        "data": {
          "privateSources": [],
          "structuredRecords": [],
          "externalSummaries": [],
          "constitutions": [],
          "profiles": [],
          "boardImports": [],
          "jointCorrections": [],
          "auditEvents": [],
          "exportManifests": [],
          "importResults": [],
          "meta": []
        }
      }
    }
  ]
}
